import { ProductCriteriaOptions } from '@services/MarppleShop/features/ProductList/type/product-list.request.ts';

/**
 * 정렬 상태를 관리하는 매니저
 */
export class SortManager {
  private sort: ProductCriteriaOptions['sort'];

  constructor(
    sort: ProductCriteriaOptions['sort'] | undefined,
    private readonly defaultSort: ProductCriteriaOptions['sort'] = 'popular',
  ) {
    // 값이 없으면 기본값으로 초기화
    this.sort = sort ?? defaultSort;
  }

  setSort(sort: ProductCriteriaOptions['sort']): this {
    this.sort = sort;
    return this;
  }

  getSort(): ProductCriteriaOptions['sort'] {
    return this.sort;
  }

  isDefault(): boolean {
    return this.sort === this.defaultSort;
  }

  reset(): this {
    this.sort = this.defaultSort;
    return this;
  }
}
